const DEFAULT_DOWNLOAD_CHANNELS = ['charge', 'qrcode', 'pc', 'android', 'apple', 'harmony'];
const CUSTOM_DOWNLOAD_CHANNELS = ['qrcode', 'android', 'apple'];

const normalizeText = value => (typeof value === 'string' ? value.trim() : '');

export function createDownloadDataSources(dataSourceIds) {
  return Object.keys(dataSourceIds)
    .filter(key => key !== 'custom_download')
    .map(key => ({
      dataSourceId: dataSourceIds[key] || '',
      page: 1,
      perPage: 99
    }));
}

export function createCustomDownloadDataSources(dataSourceIds, utmSource) {
  const normalizedUtmSource = normalizeText(utmSource);
  if (!normalizedUtmSource || !dataSourceIds.custom_download) return [];

  return [
    {
      dataSourceId: dataSourceIds.custom_download,
      page: 1,
      perPage: 1,
      contentFilter: {
        relation: 'and',
        items: [{ field: 'utm_source', operator: 'eq', value: normalizedUtmSource }]
      }
    }
  ];
}

export function getDownloadLinks(defaultItems, customItems, utmSource) {
  const links = {
    charge: '',
    qrcode: '',
    pc: '',
    android: '',
    apple: '',
    harmony: ''
  };

  (Array.isArray(defaultItems) ? defaultItems : []).forEach(item => {
    const channelCode = normalizeText(item?.download_channel_code);
    if (!DEFAULT_DOWNLOAD_CHANNELS.includes(channelCode)) return;

    links[channelCode] = normalizeText(item?.download_link?.url);
  });

  const normalizedUtmSource = normalizeText(utmSource);
  if (!normalizedUtmSource) return links;

  const customItem = (Array.isArray(customItems) ? customItems : []).find(
    item => item?.download_channel_code === 'utm_source' && item?.utm_source === normalizedUtmSource
  );
  if (!customItem) return links;

  const customUrl = normalizeText(customItem?.download_link?.url);
  CUSTOM_DOWNLOAD_CHANNELS.forEach(channelCode => {
    links[channelCode] = customUrl;
  });

  return links;
}
